import React, { useCallback, useEffect, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import styled from "styled-components/macro";

import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch } from "../../../store";
import userSlice from "../../../reducer/user";
import Modal from "../../../components/Modal";
import axios from "axios";
import qs from "qs";

const loginAxios = axios.create({
  baseURL: "https://www.farminsf.com",
});

const Container = styled.div`
  background-color: #fff;
  min-height: 100vh;
`;

const PageTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid #dddddd;
  background-color: #fff;
  padding: 15px 40px;
  width: 100%;
  .move-btn {
    width: 30px;
    & img {
      width: 100%;
    }
  }
  .pagetit {
    font-size: 1.13em;
    font-family: "spoqa500";
    margin-left: 10px;
  }

  @media screen and (min-width: 1050px) {
    font-size: 1.4em;
    p {
      & img {
        width: 30%;
      }
    }
  }
`;

const ProfileCon = styled.div`
  width: 100%;
  margin-top: 80px;
`;

const Profile = styled.div`
  width: 80%;
  background-color: #f5f5f5;
  margin: 0 auto;
  height: auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 30px;
  border: 1.5px solid lightgray;
  border-radius: 10px;
`;

const InputCon = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100px;
  width: 100%;
  background-color: #ffffff;
  margin: 30px 0;
  border-radius: 10px;
  padding: 0px 60px 0px 20px;

  div {
    color: #656565;
  }

  .name {
    margin-bottom: 10px;
  }
`;

const Input = styled.input`
  background-color: #f5f5f5;
  height: 40px;
  border: 1px solid lightgray;
  /* width: 400px; */
  width: 90%;
  height: 31px;
  color: #828588;
  padding-left: 10px;
`;

const SaveCon = styled.div`
  width: 100%;
  margin-top: 30px;
  div {
    width: 50%;
    background-color: oldlace;
    margin: 0 auto;
    background-color: #73972c;
    height: 44px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
  }
`;

const CheckBoxCon = styled.div`
  display: flex;
  margin-top: 10px;

  input[type="checkbox"] {
    appearance: none;
    width: 13px;
    height: 13px;
    border: 1.125px solid #dddddd;
    margin-right: 5px;
    position: relative;
    top: 1px;
    margin-right: 7px;
    &:checked {
      border-color: transparent;
      background-image: url("./img/checked.svg");
      background-size: 100% 100%;
      background-position: 50%;
      background-repeat: no-repeat;
      background-color: #73972c;
    }
  }
`;

const DummyWapper = styled.div`
  background-color: #fff;
`;

const ChangePassword = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [modal, setModal] = useState<boolean>(false);
  const [serachparams] = useSearchParams();
  const [checked, setChecked] = useState<boolean>(false);

  const [passwordinfo, setPasswordinfo] = useState<{
    currentPW: string;
    newPW: string;
    newconfincPW: string;
  }>({
    currentPW: "",
    newPW: "",
    newconfincPW: "",
  });

  useEffect(() => {
    dispatch(
      userSlice.actions.Routerpath(
        `/ChangePassword?userId=${serachparams.get(
          "userId"
        )}&name=${serachparams.get("name")}&memberId=${serachparams.get(
          "memberId"
        )}`
      )
    );
  }, []);

  const postfunc = useCallback(
    async (type: string) => {
      if (type === "YES") {
        if (
          !passwordinfo.currentPW ||
          !passwordinfo.newPW ||
          !passwordinfo.newconfincPW
        ) {
          if (passwordinfo.newPW.includes(" ")) {
            return confirmAlert({
              title: "새 비밀번호에 공백이 있습니다. 공백을 제거해주세요",
              buttons: [
                {
                  label: "Yes",
                },
              ],
            });
          }

          if (passwordinfo.newconfincPW.includes(" ")) {
            return confirmAlert({
              title: "새 비밀번호 확인에 공백이 있습니다. 공백을 제거해주세요",
              buttons: [
                {
                  label: "Yes",
                },
              ],
            });
          }

          return confirmAlert({
            title: "입력값을 모두 입력해주세요.",
            buttons: [
              {
                label: "Yes",
              },
            ],
          });
        }

        if (passwordinfo.newPW !== passwordinfo.newconfincPW) {
          return confirmAlert({
            title: "새 비밀번호가 일치하지 않습니다.",
            buttons: [
              {
                label: "Yes",
              },
            ],
          });
        }

        try {
          let datas = {
            userId: serachparams.get("userId"),
            password: passwordinfo.currentPW,
          };

          const currentconfirm = await axios.post(
            `/ifactory/api/isexituser`,
            datas
          );
        } catch (error) {
          console.error(error);
          setModal(false);
          // return alert("현재 비밀번호가 일치하지 않습니다.");
          return confirmAlert({
            title: "현재 비밀번호가 일치하지 않습니다.",
            buttons: [
              {
                label: "Yes",
              },
            ],
          });
        }
        try {
          let data = {
            userId: serachparams.get("userId"),
            password: passwordinfo.newPW,
          };
          const response = await axios.put(
            `/ifactory/api/member/changepassword`,
            data
          );

          if (response.status === 200) {
            confirmAlert({
              title: "비밀번호를 변경하였습니다.",
              buttons: [
                {
                  label: "Yes",
                },
              ],
            });
          }
        } catch (error) {
          console.error(error);
          setModal(false);
          return confirmAlert({
            title: "비밀번호를 변경하는데 실패하였습니다.",
            buttons: [
              {
                label: "Yes",
              },
            ],
          });
        }
        setModal(false);
        navigate("/Setting");
      } else if (type === "NO") {
        setModal(false);
      }
    },
    [modal]
  );

  const onChangefunc = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setPasswordinfo({ ...passwordinfo, [e.target.name]: e.target.value });
    },
    [passwordinfo]
  );

  return (
    <Container>
      <PageTop>
        <p className="move-btn">
          <img
            src="./img/ArrowLeft.svg"
            onClick={() => {
              navigate(-1);
            }}
          />
        </p>
        <p className="pagetit">개인설정</p>
      </PageTop>
      <ProfileCon>
        <Profile>
          <DummyWapper>
            <InputCon>
              <div className="name">현재비밀번호</div>
              <Input
                type={checked ? "text" : "password"}
                id="currentPW"
                name="currentPW"
                placeholder="현재 비밀번호"
                value={passwordinfo.currentPW}
                onChange={onChangefunc}
              />
              <CheckBoxCon>
                <input
                  type="checkbox"
                  onClick={() => setChecked((prev) => !prev)}
                />
                <div>비밀번호 표시</div>
              </CheckBoxCon>
            </InputCon>
            <InputCon>
              <div className="name">새 비밀번호</div>
              <Input
                type="password"
                id="newPW"
                name="newPW"
                placeholder="새 비밀번호"
                value={passwordinfo.newPW}
                onChange={onChangefunc}
              />
            </InputCon>
            <InputCon>
              <div className="name">새 비밀번호 확인</div>
              <Input
                type="password"
                id="newconfincPW"
                name="newconfincPW"
                placeholder="새 비밀번호 확인"
                value={passwordinfo.newconfincPW}
                onChange={onChangefunc}
              />
            </InputCon>
          </DummyWapper>
        </Profile>
      </ProfileCon>
      <SaveCon>
        <div onClick={() => setModal(true)}>저장</div>
      </SaveCon>
      {modal && (
        <Modal
          title={"비밀번호를 수정하시겠습니까?"}
          first={"예"}
          second={"아니오"}
          firstclick={() => postfunc("YES")}
          secondclick={() => postfunc("NO")}
        />
      )}
    </Container>
  );
};

export default ChangePassword;
